
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-info",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-info"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"i-info__circle",attrs:{"cx":"9","cy":"9","r":"6.15"}}),_c('g',{staticClass:"i-info__i"},[_c('path',{attrs:{"d":"M9 11.71V8.16"}}),_c('path',{attrs:{"stroke-linecap":"square","stroke-miterlimit":"10","d":"M9 6.6v.03"}})])])
          )
        }
      }
    